import { render } from "./Tem028.vue?vue&type=template&id=e1ff2854"
import script from "./Tem028.vue?vue&type=script&lang=js"
export * from "./Tem028.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__